import { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { equals, assoc, without, intersection } from 'ramda';

import { POI_FIELDS } from '../constants';
import ImageUploader from '../image-uploader/ImageUploader.jsx';

import s from './ImageEditor.module.scss';

export default class ImageEditor extends Component {
    static propTypes = {
        accountId: PropTypes.string,
        changedFields: PropTypes.arrayOf(PropTypes.string),
        disabled: PropTypes.bool,
        images: PropTypes.arrayOf(PropTypes.object),
        logo: PropTypes.arrayOf(PropTypes.object),
        onUpdatePoiField: PropTypes.func,
        openImageInNewTab: PropTypes.func,
    };

    static defaultProps = {
        accountId: '',
        changedFields: [],
        disabled: false,
        images: [],
        logo: [],
        onUpdatePoiField: () => {},
        openImageInNewTab: () => {},
    };

    shouldComponentUpdate(nextProps) {
        return !equals(nextProps.images, this.props.images) || !equals(nextProps.logo, this.props.logo);
    }

    triggerChange = (fieldName, value) => (fieldName === 'logo' ? this.props.onUpdatePoiField(fieldName, value[0]) : this.props.onUpdatePoiField(fieldName, value));

    renderDescription = text => <div className={s.subBanner}>{text}</div>;

    updateListProp = (imageListType, updatedFile, updatedProp, updatedValue) => {
        const newList = this.props[imageListType].map(f => {
            if (f.caption === updatedFile.caption && f.dateUploaded === updatedFile.dateUploaded) {
                f = assoc(updatedProp, updatedValue, f);
            }
            return f;
        });

        this.triggerChange(imageListType, newList);
    };

    updateListOrder = (imageListType, reorderedArray) => this.triggerChange(imageListType, reorderedArray);

    addToList = (imageListType, additionalItems) => {
        const newList = this.props[imageListType].concat(additionalItems);

        this.triggerChange(imageListType, newList);
    };

    removeFromList = (imageListType, itemToRemove) => {
        const newList = without([itemToRemove], this.props[imageListType]);
        this.triggerChange(imageListType, newList);
    };

    checkForFailedImages = (imageListType, containsFailedImage) => this.triggerChange(`${imageListType}HasFailedImages`, containsFailedImage);

    renderTitle = (title, fields) => {
        const isDirty = intersection(fields, this.props.changedFields).length > 0;
        const classes = classNames(s.title, { [s.dirty]: isDirty });
        return <div className={classes}>{title}</div>;
    };

    renderImageUploader = (type, list, accountId = this.props.accountId) => {
        const { disabled, openImageInNewTab } = this.props;
        return (
            <ImageUploader
                accountId={accountId}
                containsFailed={this.checkForFailedImages}
                disabled={disabled}
                imageList={list}
                onItemAdditions={this.addToList}
                onItemRemoval={this.removeFromList}
                onListOrderChange={this.updateListOrder}
                onPropChange={this.updateListProp}
                type={type}
                openImageInNewTab={openImageInNewTab}
            />
        );
    };

    render = () => {
        const { images, logo } = this.props;
        return (
            <div className={classNames(s.imageEditor)}>
                {this.renderTitle('PHOTOS', [POI_FIELDS.IMAGES])}
                {this.renderDescription('The following photos will display in the image section of the POI window')}
                {this.renderImageUploader('images', images)}

                {this.renderTitle('DIRECTORY LOGO', [POI_FIELDS.LOGO])}
                {this.renderDescription(`Directory Logos can be accessible using the Wayfinder JS-SDK for populating websites and digital kiosks`)}
                {this.renderImageUploader('logo', logo)}
            </div>
        );
    };
}
